<template>
  <v-app id="app">
    <template v-if="isLogined">
      <template v-if="isSplash">
        <vue-splash
          :show="true"
          :title="`${title} ver,${version}`"
          :logo="splash"
          color="#455A64"
          :size="100"
          custom-text="loading..."
        ></vue-splash>
      </template>

      <template v-else-if="!isSplash && isSplashError">
        <vue-splash
          :show="isSplashError"
          :title="`アプリケーション起動失敗`"
          :logo="splashError"
          color="#455A64"
          :size="100"
          custom-text="システム管理者にお問い合わせください"
        ></vue-splash>
      </template>
      <template v-else>
        <!-- <v-app id="app"> -->
        <router-view />
        <!-- </v-app> -->
      </template>
    </template>

    <!-- ログイン等認証画面表示用 -->
    <template v-else>
      <!-- <v-app id="app"> -->
      <router-view />
      <!-- </v-app> -->
    </template>

    <v-snackbar bottom right tile :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="warning" v-bind="attrs" @click="snackbar.show = !snackbar.show"> 閉じる </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import webconfig from '@/web-configs';

import Splash from '@/assets/splash.svg';
import SplashError from '@/assets/warning.svg'; // https://www.flaticon.com/free-icon/warning_159469?term=error&page=1&position=1&page=1&position=1&related_id=159469&origin=search

export default {
  name: 'App',
  computed: {
    title() {
      return webconfig.web.title;
    },

    splash() {
      return Splash;
    },
    splashError() {
      return SplashError;
    },

    snackbar: {
      get() {
        return this.$store.getters.snackbar;
      },
      set(val) {
        this.$store.commit('setSnackbar', val);
      },
    },

    toast: {
      get() {
        return this.$store.getters.toast;
      },
      set(val) {
        this.$store.commit('setToast', val);
      },
    },

    isSplash() {
      return this.$store.getters.isSplash;
    },
    isSplashError() {
      return this.$store.getters.isSplashError;
    },
  },

  data: () => ({
    //
  }),
  methods: {
    createTitleDesc(routeInstance) {
      // タイトルを設定
      if (routeInstance.meta.title) {
        let setTitle = routeInstance.meta.title;
        document.title = `${webconfig.web.title}:{0}`.format(setTitle);
      } else {
        document.title = webconfig.web.title; // タイトル空の場合
      }

      // メタタグdescription設定
      if (routeInstance.meta.desc) {
        let setDescription = routeInstance.meta.description;
        document.querySelector("meta[name='description']").setAttribute('content', setDescription);
      } else {
        document.querySelector("meta[name='description']").setAttribute('content', webconfig.web.description);
      }
    },
    onHideSnackbar() {
      this.$store.state.snackbar.show = false;
    },
  },

  watch: {
    $route(routeInstance, from) {
      this.createTitleDesc(routeInstance, from);
    },

    toast: {
      handler: function (val) {
        this.$toasted.show(val.message, val);
      },
      deep: true,
    },
  },
  mounted() {
    this.createTitleDesc(this.$route);

    this.$nextTick(() => {
      // この時点でログインしていれば スプラッシュ処理を行い、アプリケーション初期化
      if (this.isLogined) {
        this.$store.dispatch('splashApp');
      }
    });
  },
};
</script>


<style scoped>
@import './styles/style.css';
</style>